<!--
 * @message: 图片上传组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-21 14:40:26
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_ImgDragUpdate.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-20 10:05:41
-->
<template>
  <div
    :style="{
      border: disabled
        ? 'none'
        : !isError
        ? '2px dashed var(--main-border-color)'
        : '2px dashed red',
    }"
    class="rounded pa-3 max-width"
    @dragover="fileDragover"
    @drop="fileDrop"
  >
    <v-sheet class="text--secondary" v-if="fileList.length == 0 && disabled">{{
      $t("label_essweb_update_components_noContentLabel")
    }}</v-sheet>
    <v-file-input
      id="fileInput"
      hide-input
      v-show="false"
      @change="chooseUploadFile"
    ></v-file-input>

    <v-sheet v-if="fileList.length" class="text-left align-center">
      <v-list-item
        two-line
        v-for="(item, index) in fileList"
        :key="item.id"
        class="rounded mt-2 pt-2 pb-2"
        style="border: 1px solid var(--main-border-color)"
      >
        <v-list-item-avatar
          class="pa-0 pt-2 pb-2 mt-0 mb-0"
          size="80"
          tile
          @click="
            curImageIndex = index;
            showImageBox = true;
          "
        >
          <svg-icon
            size="72"
            fill="grey"
            iconClass="photo"
            v-if="!item.updated"
          />
          <v-img :src="item.imageUrl" v-if="item.updated"></v-img>
          <v-sheet
            style="
              position: absolute;
              background: rgba(0, 0, 0, 0.4);
              font-size: 12px;
            "
            class="d-flex text-center align-center justify-center white--text"
            width="100%"
            height="100%"
            v-if="item.uploading"
          >
            <v-progress-circular
              indeterminate
              :rotate="10"
              :size="24"
              :width="2"
              color="primary"
            ></v-progress-circular>
          </v-sheet>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.filename }}</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip x-small>{{ $byteconvert(item.size) }}</v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="!disabled">
          <v-btn
            small
            icon
            @click="deleteItem(item.id, item)"
            v-if="item['save'] !== true"
          >
            <span class="material-icons-round">delete</span>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-sheet>
    <v-sheet
      v-if="single ? fileList.length == 0 : true"
      class="text-center align-center"
    >
      <div v-if="fileList.length == 0 && !disabled">
        <i class="material-icons-round md-72 text--secondary lighten-2"
          >backup</i
        >
      </div>
      <div class="pt-3" v-if="!disabled">
        <span>{{ $t("label_essweb_update_components_tipLabel") }}</span>
        <v-btn
          color="primary lighten-2 "
          small
          rounded
          class="text-capitalize ml-2"
          @click="toChoose"
          >{{ $t("label_essweb_update_components_browseBtnLabel") }}</v-btn
        >
      </div>
    </v-sheet>
    <LightBox
      :show="showImageBox"
      @close="showImageBox = false"
      :index="curImageIndex"
      :imageList="imageList"
    />
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "ImgDragUpdate",
  props: {
    single: { default: false, type: [Boolean, Number, String] },
    required: { default: false, type: [Boolean, Number, String] },
    disabled: { default: false, type: [Boolean, Number, String] },
    closePop: { default: false, type: [Boolean, Number, String] },
    save: { default: false, type: [Boolean, Number, String] },
    defaultImageList: {
      default: function () {
        return [];
      },
      type: [Array, String, Object],
    },
  },
  computed: {
    ...mapGetters(["AppInfo", "companyLang", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    imageList() {
      return this.fileList.filter((item) => item.updated === true);
    },
  },
  data() {
    return {
      file: null,
      isError: false,
      fileList: [],
      curImageIndex: 0,
      showImageBox: false,
    };
  },
  mounted() {
    //初始化
    if (this.defaultImageList.length) {
      const that = this;
      let val = this.defaultImageList;
      if (val == null || val == "") return;
      if (this.fileList.length) return;
      if (
        Object.prototype.toString.call(val).toLowerCase() ===
          "[object array]" &&
        val.length === 0
      ) {
        // 空数组
        return false;
      }
      this.fileList = [];
      if (val)
        if (
          typeof val == "object" &&
          Object.prototype.toString.call(val).toLowerCase() ==
            "[object object]" &&
          !val.length
        ) {
          this.fileList = [
            {
              id: val["uuid"] ? val["uuid"] : dayjs().valueOf(),
              filename: val.file_name,
              size: Number(val.size),
              save: val.save ? val.save : false,
              file: null,
              uploading: false,
              imageUrl: val.path,
              updated: true,
            },
          ];
        } else {
          if (val.length == 0) return;
          val.forEach((item, index) => {
            that.fileList.push({
              id: item["uuid"] ? item["uuid"] : dayjs().valueOf(),
              filename: item.file_name,
              size: Number(item.size),
              save: item.save ? item.save : false,
              image: item,
              file: null,
              uploading: false,
              imageUrl: item.path,
              updated: true,
            });
          });
        }
    }
  },
  watch: {
    save(val) {
      if (val)
        this.fileList.map((item) => {
          item["save"] = true;
        });
    },
    closePop() {
      this.showImageBox = false;
    },
    defaultImageList(val, old) {
      const that = this;
      if (val == null || val == "") return;
      if (this.fileList.length) return;
      if (
        Object.prototype.toString.call(val).toLowerCase() ===
          "[object array]" &&
        val.length === 0
      ) {
        // 空数组
        return false;
      }
      this.fileList = [];
      if (val)
        if (
          typeof val == "object" &&
          Object.prototype.toString.call(val).toLowerCase() ==
            "[object object]" &&
          !val.length
        ) {
          this.fileList = [
            {
              id: val["uuid"] ? val["uuid"] : dayjs().valueOf(),
              filename: val.file_name,
              size: Number(val.size),
              file: null,
              save: val.save ? val.save : false,
              uploading: false,
              imageUrl: val.path,
              updated: true,
            },
          ];
        } else {
          if (val.length == 0) return;
          val.forEach((item, index) => {
            that.fileList.push({
              id: item["uuid"] ? item["uuid"] : dayjs().valueOf(),
              filename: item.file_name,
              size: Number(item.size),
              image: item,
              save: item.save ? item.save : false,
              file: null,
              uploading: false,
              imageUrl: item.path,
              updated: true,
            });
          });
        }
    },
    imageList(val) {
      let arr = [];
      if (val.length) {
        if (this.single) {
          arr = val[0]["image"];
        } else {
          val.map((item) => {
            arr.push(item["image"]);
          });
        }
      } else {
        arr = [];
      }
      this.$emit("change", arr);
      this.validate();
    },
    fileList(val) {
      const that = this;
      val.forEach((item) => {
        if (!item.updated) {
          that.toUpdate(item.file, item.id);
        }
      });
    },
  },
  methods: {
    validate() {
      const that = this;
      return new Promise((resolve, reject) => {
        if (!that.required) resolve(true);
        else {
          if (that.fileList && that.fileList.length <= 0) {
            that.isError = true;
            resolve(false);
          } else {
            that.isError = false;
            resolve(true);
          }
        }
      });
    },
    chooseUploadFile: function (file) {
      if (!file) return;
      if (!/\.(gif|jpg|jpeg|png|GIF|JPG|PNG|webp|BMP|bmp)$/.test(file.name)) {
        this.$showMessage({
          type: "error",
          color: "error",
          text: this.$t("message_essweb_update_components_onlyUpdateImgLabel"),
        });
        return false;
      }
      if (file.size > 5 * 1000 * 1000) {
        this.$showMessage({
          type: "error",
          color: "error",
          text:
            this.$t("message_essweb_update_components_sizeLessThanLabel") +
            "5MB.",
        });
        return false;
      }

      this.fileList.push({
        id: dayjs().valueOf(),
        filename: file.name,
        size: file.size,
        file: file,
        save: false,
        image: {
          path: "",
          size: file.size,
          file_name: file.name,
          name: file.name,
          uuid: null,
        },
        imageUrl: "",
        uploading: false,
        updated: false,
      });
      $("#fileInput").val(null);
    },
    fileDragover: function (e) {
      e.preventDefault();
    },
    fileDrop: function (e) {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (!/\.(gif|jpg|jpeg|png|GIF|JPG|PNG|webp|BMP|bmp)$/.test(file.name)) {
        this.$showMessage({
          type: "error",
          color: "error",
          text: this.$t("message_essweb_update_components_onlyUpdateImgLabel"),
        });
        return false;
      }
      if (file.size > 5 * 1000 * 1000) {
        this.$showMessage({
          type: "error",
          color: "error",
          text:
            this.$t("message_essweb_update_components_sizeLessThanLabel") +
            "5MB.",
        });
        return false;
      }
      this.fileList.push({
        id: dayjs().valueOf(),
        filename: file.name,
        size: file.size,
        file: file,
        save: false,
        image: {
          path: "",
          size: file.size,
          file_name: file.name,
          name: file.name,
          uuid: null,
        },
        imageUrl: "",
        uploading: false,
        updated: false,
      });
    },
    deleteItem: function (id, item) {
      const that = this;
      that.bindAvatar("", item.image.uuid).then((res) => {
        that.fileList = that.fileList.filter((ele) => ele.id !== id);
      });
    },
    toChoose: function () {
      $("#fileInput").click();
    },
    setFileArgs(id, obj) {
      this.fileList.map((item) => {
        if (item.id === id) {
          for (let key in obj) {
            if (item[key] !== undefined) item[key] = obj[key];
          }
        }
      });
    },
    getUploadInfo: function (name, size, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true });
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-record-plan/",
            data: {
              module_uuid: "upload",
              attachment_data_field: that.curAppInfo["user"]["thumbnail_img"],
              org_level_uuid: that.curAppInfo["user"]["org_level_uuid"],
              attachment_title: name,
              attachment_size: size,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false });
            reslove(res);
          })
          .catch((err) => {
            that.setFileArgs(curId, { uploading: false });
            reject(err);
          });
      });
    },
    //删除图片
    async bindAvatar(uuid, del = "") {
      const that = this;
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/staff-manager/upload_staff_avatar/",
            data: {
              user_id: that.curAppInfo["user"]["user_id"],
              uuid: that.curAppInfo["user"]["uuid"],
              thumbnail_img: uuid,
              del: del,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            reslove(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async onUploadAvatar(uuid, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true });
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/get-file-info/",
            data: { uuid: uuid },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false });
            reslove(res);
          })
          .catch((err) => {
            that.setFileArgs(curId, { uploading: false });
            reject(err);
          });
      });
    },
    async UploadAvatar(file, arg, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true });
      return await new Promise((reslove, reject) => {
        that.$azureUpload(
          {
            baseUrl: arg.upload_url.split("?")[0],
            sasToken: arg.sostoken,
            debug: false,
            file: file,
            progress: (progress) => {
              // console.log(progress);
            },
            complete: (res) => {
              that.setFileArgs(curId, { uploading: false });
              reslove(true);
            },
            error: (err) => {
              that.setFileArgs(curId, { uploading: false });
              reject(err);
            },
            blockSize: file.size,
          },
          axios.create()
        );
      });
    },
    async callBackUpload(result, uuid, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true });
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-callback/",
            data: {
              result: result,
              uuid: uuid,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false });
            reslove(res);
          })
          .catch((err) => {
            that.setFileArgs(curId, { uploading: false });
            reject(err);
          });
      });
    },
    async toUpdate(file, id) {
      const that = this;
      await that
        .getUploadInfo(file.name, file.size, id)
        .then((res) => {
          that
            .UploadAvatar(file, res.data, id)
            .then((result) => {
              if (result === true) {
                that
                  .callBackUpload(1, res.data.uuid, id)
                  .then((resu) => {
                    if (resu.data.type == "update") {
                      that
                        .onUploadAvatar(res.data.uuid, id)
                        .then((resul) => {
                          // 上传成功
                          that.setFileArgs(id, {
                            updated: true,
                            image: resul.data["files"][0],
                            imageUrl: resul.data["files"][0].path,
                          });
                        })
                        .catch((err) => {});
                    } else {
                      //上报失败
                    }
                  })
                  .catch((err) => {
                    console.log(err); //上报失败
                  });
              }
            })
            .catch((err) => {
              // 上传失败
              console.log(err);
              that.callBackUpload(0, res.data.uuid, id);
            });
        })
        .catch((err) => {
          console.log(err);
        });
      // this.$azureUpload(
      //   {
      //     baseUrl:
      //       "https://essenceassets.blob.core.windows.net/web/ess-admin/images/" +
      //       f.name, // baseUrl for blob file uri (i.e. http://<accountName>.blob.core.windows.net/<container>/<blobname>),
      //     sasToken:
      //       "?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-10-29T12:01:10Z&st=2020-10-29T04:01:10Z&spr=https&sig=155BaSJcEpl53QzivfCBNQAURYoks5fRKAPtyjIfw4g%3D",
      //     // "?sv=2019-12-12&ss=b&srt=o&sp=rwdlacx&se=2021-12-01T19:12:48Z&st=2020-07-25T11:12:48Z&spr=https&sig=KEW3tN7rmSSNIMdqj5mkE5DhB50qOV6mwItevEbVrtM%3D",
      //     // "?se=2020-07-22T08%3A55%3A37Z&sp=rwl&sv=2018-03-28&sr=c&sig=xbonYAfnWwVnxNHN66C6KLgaP0GzHkdosnCa1F5aC%2Bc%3D", // Shared access signature querystring key/value prefixed with ?,
      //     file: f, // File object using the HTML5 File API,
      //     progress: (progress) => {
      //       // console.log(progress);
      //     }, // progress callback function,
      //     complete: (res) => {
      //       that.fileList.forEach((item) => {
      //         if (item.id == id) {
      //           item.updated = true;
      //           item.imageUrl =
      //             "https://essenceassets.blob.core.windows.net/web/ess-admin/images/" +
      //             f.name;
      //         }
      //       });
      //     }, // complete callback function,
      //     error: (err) => {}, // error callback function,
      //     blockSize: f.size, // Use this to override the DefaultBlockSize,
      //   },
      //   axios.create()
      // );
    },
  },
};
</script>
